import React from 'react'
import { Button, Flex, Popconfirm, Table, TableProps } from 'antd'
import { useTranslation } from 'react-i18next'
import { DeleteOutlined } from '@ant-design/icons'
import { Client } from '../client'
import { UserAvatar } from '../../user/components/user-avatar'
import { MailLink } from '../../components/mail-link'
import { useDeleteClient } from '../hooks'
import { useAuth } from '../../auth'
import { DELETE_CLIENT } from '../../user/permission'
import { ClientCampaignAssign } from './client-campaign-assign'

export function ClientTable(props: TableProps<Client>) {
    const { t } = useTranslation()
    const { can } = useAuth()

    return (
        <Table
            size="small"
            rowKey="userId"
            columns={[
                {
                    title: '',
                    dataIndex: 'avatar',
                    width: 60,
                    render(text) {
                        return <UserAvatar user={{ avatar: text }} />
                    },
                },
                { title: t('Name'), dataIndex: 'name' },
                { title: t('Email'), dataIndex: 'email', render: (email) => <MailLink email={email} /> },
                {
                    width: 400,
                    title: t('Assigned campaigns'),
                    key: 'assigned_campaigns',
                    render: (_, record) => <ClientCampaignAssign client={record} />,
                },
                {
                    key: 'action',
                    width: 50,
                    hidden: !can(DELETE_CLIENT),
                    render: (_, record) => (
                        <Flex justify="end">
                            <DeleteClientButton
                                companyId={record.companyId}
                                userId={record.userId}
                            />
                        </Flex>
                    ),
                },
            ]}
            {...props}
        />
    )
}

function DeleteClientButton({ companyId, userId }: { companyId: string; userId: string }) {
    const mutation = useDeleteClient(companyId, userId)
    const { t } = useTranslation()

    return (
        <Popconfirm
            title={t('Are you sure?')}
            onConfirm={() => mutation.mutate()}
        >
            <Button
                type="text"
                loading={mutation.isPending}
                icon={<DeleteOutlined />}
            />
        </Popconfirm>
    )
}
